<template>
    <html data-wf-page="5b17a0c3e17ccd5653bd4f4e" data-wf-site="5b1755d5269b9c5142d82ca3">
<head>
  <meta charset="utf-8">
  <title>Cabinet Manager | Dashboard</title>
  <meta content="Cabinet Manager | Dashboard" property="og:title">
  <meta content="width=device-width, initial-scale=1" name="viewport">
</head>
<body class="body-2">
  <MobileNav :project="project" :current-page="'dashboard'"></MobileNav>
  <div class="wholewrapper">
    <div class="div-block-24">
      <NavSideBar :current-page="'dashboard'" :project="project"></NavSideBar>
      <div class="contentcontainer">
        <div class="contenttop">
          <div class="div-block-30">
            <div class="projectselector">
              <el-dropdown trigger="click" @command="switchProject" style="max-width:40vw">
                <span class="el-dropdown-link" style="color: #fff; font-weight: bold; word-wrap: break-word">{{ project.name }}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="project in projectList"
                    v-show="project.status !== 'closed'"
                    :key="project.id"
                    :command="project.id">{{ project.name }}
                  </el-dropdown-item>
                  <el-dropdown-item divided
                    :command="''">All Projects
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <SignInButton :user="user" @login="$emit('login')"></SignInButton>
          </div>
          <div class="div-block-32">
            <div class="text-block-16">Design Drawing</div>
          </div>
        </div>
        <div class="contentdown">
          <div class="downcontentdrawings">
            <el-button @click="showAddDrawing" type="primary" round plain class="add-drawing-button">Add Design Drawing</el-button>
            <div class="tip">Your browser is too small. Resize your window to add/edit drawings.</div>
            <el-table
              v-if="groupedDrawingList.length > 0"
              :data="groupedDrawingList"
              style="margin-top:24px;width:100%">
              <el-table-column
                prop="pageId"
                label="Page #">
              </el-table-column>
              <el-table-column label="Active Revision">
                <template slot-scope="scope">
                  <el-popover
                    placement="bottom"
                    width="300"
                    trigger="hover">
                    <p style="font-size: 1.5em; font-weight: bold;">Active Revision</p>
                    <p>Only active revision of each drawing will be counted when doing count or export</p>
                    <div slot="reference">
                      <el-tag size="medium">{{ scope.row.revisions[0].activePage ? scope.row.revisions[0].revision : 'NO ACTIVE REVISION'}}</el-tag>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column label="Last Update">
                <template slot-scope="scope">
                  {{ scope.row.revisions[0].updateDate }}
                </template>
              </el-table-column>
              <el-table-column label="Actions">
                <template slot-scope="scope">
                  <el-cascader
                    :options="actionOptionList[scope.$index]"
                    v-model="selectedAction"
                    @change="handleAction"
                    placeholder="Select an action">
                  </el-cascader>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="powereddiv">
            <div class="div-block-14">
              <div class="text-block-9">Powered by </div>
              <a href="http://studioscreation.com" target="_blank" class="poweredlink w-inline-block">
                <div class="text-block-10">Studio S, Inc.</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <AddDrawingForm v-if="displayAddDrawing"
    @close-add-drawing="closeAddDrawing"
    @next-add-drawing="nextAddDrawing"
    :project-data="project"
    :exists-page-ids="existsPageIds"
    :key="formKey">
  </AddDrawingForm>
  <EditDrawingForm v-if="displayEditDrawing"
    @close-edit-drawing="closeEditDrawing"
    :project-data="project"
    :drawing-id="editingDrawingId">
  </EditDrawingForm>
  <CopyDrawingForm v-if="displayCopyDrawing"
    @close-copy-drawing="closeCopyDrawing"
    :project-data="project"
    :drawing-id="editingDrawingId"
    :exists-page-ids="existsPageIds">
  </CopyDrawingForm>
</body>
</html>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/webfont/1.4.7/webfont.js" type="text/javascript"></script>
<script type="text/javascript">WebFont.load({  google: {    families: ["Ubuntu:300,300italic,400,400italic,500,500italic,700,700italic","Roboto:100,100italic,300,300italic,regular,italic,500,500italic,700,700italic,900,900italic","Dosis:regular,500,600,700,800"]  }});</script>

<!-- [if lt IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/html5shiv/3.7.3/html5shiv.min.js" type="text/javascript"></script><![endif] -->
<script type="text/javascript">!function(o,c){var n=c.documentElement,t=" w-mod-";n.className+=t+"js",("ontouchstart"in o||o.DocumentTouch&&c instanceof DocumentTouch)&&(n.className+=t+"touch")}(window,document);</script>
<script src="https://code.jquery.com/jquery-3.3.1.min.js" type="text/javascript" integrity="sha256-FgpCb/KJQlLNfOu91ta32o/NMZxltwRo8QtmkMRdAu8=" crossorigin="anonymous"></script>
<script src="../static/js/t2-cabinets-management-system.js" type="text/javascript"></script>
<!-- [if lte IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/placeholders/3.0.2/placeholders.min.js"></script><![endif] -->

<script>
import { db } from '../main'
import SignInButton from './SignInButton'
import AddDrawingForm from './AddDrawingForm'
import EditDrawingForm from './EditDrawingForm'
import CopyDrawingForm from './CopyDrawingForm'
import NavSideBar from "./NavSideBar"
import MobileNav from "./MobileNav"
import drawingService from '../../static/js/drawing'

export default {
  name: 'ProjectDashboard',
  props: ['user'],
  data () {
    return {
      currentProject: "NO_PROJECT_SELECTED",
      projectList: [],
      project: {},
      displayAddDrawing: false,
      displayEditDrawing: false,
      editingDrawingId: '',
      deletingDrawingId: '',
      displayCopyDrawing: false,
      drawingList: [],
      actionOptionList: [],
      selectedAction: [],
      itemPool: [],
      formKey: 1 // form key used for avoid reuse of add form component reuse, will grow up with new form
    }
  },
  firestore () {
    return {
      projectList: db.collection('project_list').where('version', '==', 2).orderBy('last_open_date','desc').limit(15),
      project: db.collection('project').doc('Project-1')
    }
  },
  computed: {
    groupedDrawingList: function () {
      return groupDrawingList(this.drawingList)
    },
    existsPageIds: function () {
      let existsPageIds = []
      for (let page of this.groupedDrawingList) {
        existsPageIds.push(page.pageId.toLowerCase())
      }
      return existsPageIds
    }
  },
  created: function () {
    this.currentProject = this.$route.query.project
    // console.log('current project init, link to project')
    this.linkProject(this.currentProject)
  },
  watch: {
    $route: function () {
      this.currentProject = this.$route.query.project
    },
    currentProject: function () {
      // console.log('current project changed, link to new project')
      this.linkProject(this.currentProject)
      this.linkDrawingList(this.currentProject)
      // this.$notify({
      //   title: 'Success',
      //   message: 'Switched to ' + this.currentProject,
      //   type: 'success',
      //   duration: 3000,
      //   offset: 64
      // })
    },
    project: function () {
      // watch for project ready, if ready, link to unit data
      if(this.project.active_unit_build && this.project.id){
        // console.log('link to project items')
        this.$bind('itemPool', db.collection('project').doc(this.project.id).collection('item'))
      }
    },
    groupedDrawingList: function () {
      if (this.groupedDrawingList && this.groupedDrawingList.length > 0) {
        let actionList = []
        for(var i = 0; i < this.groupedDrawingList.length; i++) {
          let layerOne = {
            value: this.groupedDrawingList[i].pageId,
            label: this.groupedDrawingList[i].pageId,
            children: []
          }
          for(var j = 0; j < this.groupedDrawingList[i].revisions.length; j++){
            let layerTwo = {
              value: this.groupedDrawingList[i].revisions[j].drawingId,
              label: this.groupedDrawingList[i].revisions[j].revision,
              children: [
                {value: 'edit', label: 'Edit'},
                {value: 'copy', label: 'Duplicate As'},
                {value: 'active', label: 'Active'},
                {value: 'delete', label: 'Delete Revision'}
              ]
            }
            layerOne.children.push(layerTwo)
          }
          actionList.push([layerOne])
        }
        this.actionOptionList = actionList
      }
    }
  },
  methods: {
    switchProject: function (projectId) {
      // console.log('switch to =>', projectId)
      if (projectId !== ''){
        this.$router.push({
          path: 'dashboard',
          query: {
            project: projectId
          }
        })
      } else {
        this.$router.push({
          path: '/'
        })
      }
    },
    linkProject: function (projectId) {
      this.$bind('project', db.collection('project').doc(projectId))
    },
    linkDrawingList: function (projectId) {
      this.$bind('drawingList', db.collection('drawings').where('projectId','==', projectId).where('removed','==',false).orderBy('pageId'))
    },
    closeAddDrawing: function () {
      this.displayAddDrawing = false
    },
    nextAddDrawing: function () {
      this.closeAddDrawing()
      this.showAddDrawing()
    },
    showAddDrawing: function () {
      this.formKey ++
      this.displayAddDrawing = true
    },
    closeEditDrawing: function () {
      this.displayEditDrawing = false
    },
    closeCopyDrawing: function () {
      this.displayCopyDrawing = false
    },
    handleAction: async function (actionPath) {
      // console.log('action path', actionPath)
      let that = this
      if(actionPath[2] === 'active'){
        let activeResult = await drawingService.setActiveRevision(actionPath[1])
        if (activeResult.success) {
          // that.$notify({
          //   title: 'Success',
          //   message: `Revision <${activeResult.newRevision}> activated`,
          //   type: 'success',
          //   duration: 3000,
          //   offset: 64
          // })
        } else {
          // that.$notify({
          //   title: 'Error',
          //   message: 'Unable to set the revision, please try again',
          //   type: 'error',
          //   duration: 3000,
          //   offset: 64
          // })
        }
      } else if (actionPath[2] === 'edit') {
        that.editingDrawingId = actionPath[1]

        that.displayAddDrawing = false
        that.displayCopyDrawing = false

        that.displayEditDrawing = true
      } else if (actionPath[2] === 'copy') {
        that.editingDrawingId = actionPath[1]

        that.displayEditDrawing = false
        that.displayAddDrawing = false

        that.displayCopyDrawing = true
      } else if (actionPath[2] === 'delete') {
        let drawingId = actionPath[1]
        try {
          if (!drawingId) {
            throw 'No drawing ID'
          }
          let deleteResult = await drawingService.deleteDrawing(drawingId)
          if (!deleteResult) {
            throw 'Error while deleting the drawing'
          }
          // that.$notify({
          //   title: 'Success',
          //   message: `Revision deleted`,
          //   type: 'success',
          //   duration: 3000,
          //   offset: 64
          // })
        } catch (err) {
          console.warn(err)
          // that.$notify({
          //   title: 'Error',
          //   message: 'Unable to delete the revision, please try again',
          //   type: 'error',
          //   duration: 3000,
          //   offset: 64
          // })
        }

      }
    }
  },
  components: {
    SignInButton,
    AddDrawingForm,
    EditDrawingForm,
    CopyDrawingForm,
    NavSideBar,
    MobileNav
  }
}

function groupDrawingList(drawingList) {
  // console.log(drawingList)
  let groupedList = []
  if (!(drawingList.length > 0)) {
    return groupedList
  }
  let currentPage = {
    pageId: drawingList[0].pageId,
    revisions: [],
  }
  for (let drawing of drawingList) {
    if (drawing.pageId === currentPage.pageId) {
      if (drawing.activePage) {
        currentPage.revisions.unshift(drawing)
      } else {
        currentPage.revisions.push(drawing)
      }
    } else {
      groupedList.push(currentPage)
      currentPage = {
        pageId: drawing.pageId,
        revisions: [drawing]
      }
    }
  }
  groupedList.push(currentPage)

  // SORT THE DRAWING LIST
  groupedList.sort(comparePageId)
  return groupedList
}

function comparePageId (drawingA, drawingB) {
    let numberRegex = /\d+(\.\d+)?/
    let pageA = drawingA.pageId.match(numberRegex) === null ? null : parseFloat(drawingA.pageId.match(numberRegex)[0])
    let pageB = drawingB.pageId.match(numberRegex) === null ? null : parseFloat(drawingB.pageId.match(numberRegex)[0])
    if (pageA === null && pageB === null) {
        return drawingA.pageId.localeCompare(drawingB.pageId)
    } else if (pageA === null) {
        return 1
    } else {
        return pageA - pageB
    }
}
</script>

<style scoped>
.tip {
  display: none;
}
@media screen and (max-width: 767px) {
  .add-drawing-button {
    display: none;
  }
  .tip {
    display: block;
    color: #D32F2F;
    font-size: 14px;
  }
  .projectselector {
    display: -webkit-box !important;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    height: 84px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectDashboard.vue